<template>
  <div :style="style" @click.stop.prevent="showPopup"  >
    <div  class="pointer d-flex flex-row align-items-center btn-label"  @click.stop.prevent="showPopup">
      <span class="f14-l19 bold  " >{{ this.cook_and_me.popup_data.title  }}</span>
      <CaretComponent :open="show_popup" class="caret-position-default" variant="red" />

        <div v-show="show_popup" class="regular_text">
          <CookAndMePopupComponent :popup_data="this.cook_and_me.popup_data" />
        </div>

      </div>
    <BGClickCatcherComponent v-show="show_popup" @click.stop.prevent="showPopup" />
  </div>
</template>
<script>
import BGClickCatcherComponent from "@/components/popup/BGClickCatcherComponent";
import CookAndMePopupComponent from "./CookAndMePopupComponent.vue";
import {addGoogleAnalyticsDataLayer} from '@/modules/configuration.js';
import CaretComponent from "@/components/CaretComponent.vue";
export default {
  components: {
    BGClickCatcherComponent,
    CookAndMePopupComponent,
    CaretComponent

  },
  props: {
    cook_and_me: Object,
  },
  data() {
    return {
      show_popup: false
    }
  },
  computed: {
    style() {
      return "position:absolute; top: 15px; right: 20px;";
    },
  },
  methods: {
    async showPopup() {
      this.show_popup = !this.show_popup;
      if (this.show_popup) {
          await this.$nextTick();
          addGoogleAnalyticsDataLayer(this.cook_and_me.data_layer);
        }
    },
  }
}
</script>
<style scoped>
.btn-label {
  color: #EF3D49;
  top: 15px;
  right: 20px;
  background-color: rgba(255, 255, 255, 0.8);
  border-radius: 10px;
  padding-left:5px;
  padding-right:5px;
  padding-top: 3px;
  padding-bottom: 3px;
}
.regular_text {
  color: #38383b;
}


</style>
